import(/* webpackMode: "eager" */ "/app/src/app/network-dao/page.tsx")